/*
 * global object for js app
 */
var TINK = {
    lang: {},
    timeoutDelay: 600
};

var HTTP_STATUS_RELOAD = 480;
var HTTP_CONFLICT_STATUS = 409;
var HTTP_FORBIDDEN_STATUS = 403;

var PRODUCT_LIST_MAX_SIZE = 64;

// translation: get proper value from TINK.lang, which is defined by locale
TINK.tr = function (text) {
    if (TINK.lang[$('html').attr('lang')] && TINK.lang[$('html').attr('lang')][text]) {
        return TINK.lang[$('html').attr('lang')][text];
    }
    return text;
};

TINK.formatCurrency = function (amount) {
    if (lang === 'fr') {
        return amount + ' $';
    } else {
        return '$' + amount;
    }
};

// Trims and removes non-numeric characters from string to make a standard number. Works with FR/EN ('6,40 $' => '6.40')
TINK.sanitizeNumber = function (value) {
    if (value) {
        let amount = value.trim().replace(/,+/g, '.').replace(/[^\d.]+/g, '');
        if (!isNaN(amount)) {
            return amount;
        }
    }
    return '';
};

//Verify if its an old Android browser
var ua = navigator.userAgent;
var is_native_android = ((ua.indexOf('Mozilla/5.0') > -1 && ua.indexOf('Android ') > -1 && ua.indexOf('AppleWebKit') > -1) && (ua.indexOf('Version') > -1));

// cookies management - WATCH OUT for secure/httponly cookie added by citrix
TINK.getCookie = function (c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
};

TINK.setCookie = function (c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + "; path=/";
};

TINK.deleteCookie = function (c_name) {
    document.cookie = c_name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
};

TINK.deleteCookies = function () {
    for (var pos = 0; pos < arguments.length; pos++) {
        document.cookie = arguments[pos] + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    }
};

// Scan a form and reset fields that have a data-initial-value attribute.
TINK.resetFormFields = function (form_element) {

    // Hide error summary
    $(form_element).find(".error-summary").addClass("hide");

    $(form_element).find(".as--disabled").removeClass("as--disabled");

    // Remove all error classes on fields and labels
    $(form_element).find('.error').each(function () {
        $(this).removeClass('error');
    });

    // Reset field values
    $(form_element).find('[data-initial-value]').each(function () {
        if ($(this).is('input[type=checkbox]')) {
            $(this).prop('checked', $(this).attr('data-initial-value') == 'true').prop('disabled', false);
        } else {
            $(this).val($(this).data('initial-value'));
        }
    });
};

TINK.redirectIfConflict = function (jqXHR, reloadOnForbidden) {
    console.error('Ajax error: ' + jqXHR.status);
    if (jqXHR.status === HTTP_CONFLICT_STATUS) {
        const newLocation = jqXHR.getResponseHeader("Location");

        // avoid an infinite redirection loop if an ajax error occurs in the internal server error page and the browser is already there
        if ((typeof inInternalServerErrorPage !== 'undefined' && inInternalServerErrorPage) && (newLocation === '/erreur/500' || newLocation === '/en/error/500')) {
            return false;
        }

        if (isInWebview() && (newLocation === '/erreur/401' || newLocation === '/en/error/401')) {
            // For AJAX calls in web view mode, page 401 might not function correctly if the browser disallows the HTTP Header Referer.
            // As a workaround, the message will be sent here instead of redirecting to page 401
            sendSessionExpirationToDevice(window.location.href);
        } else {
            window.location = newLocation;
        }

        return true;
    } else if ((jqXHR.status === HTTP_FORBIDDEN_STATUS && (reloadOnForbidden || reloadOnForbidden === undefined)) || jqXHR.status === HTTP_STATUS_RELOAD) {
        window.location.reload(true);
        return true;
    }
    return false;
};

TINK.handleAjaxError = function (jqXHR) {
    if (!TINK.redirectIfConflict(jqXHR) && jqXHR.responseJSON) {
        let response = jqXHR.responseJSON;
        if (response.redirect) {
            window.location.href = response.redirect;
        } else if (response.errorMessages) {
            $('.ajaxError').removeClass('hide');
            $('.ajaxError .alert--error').text(response.errorMessages[0]);
        }
    }
};

TINK.sessionAjax = function (options) {
    // CSRF AJAX protection
    var csrfToken = $("meta[name='_csrf']").attr("content");
    var csrfHeader = $("meta[name='_csrf_header']").attr("content");

    var defaults = {
        beforeSend: function (xhr) {
            if (csrfHeader) xhr.setRequestHeader(csrfHeader, csrfToken);
            else console.info('CSRF meta token is absent!');
        }
    };
    $.extend(options, defaults);
    return $.ajax(options);
};

TINK.validateUrl = function (url) {
    if (url.indexOf("?") === -1) {
        return url.replace("&", "?");
    }
    return url;
};

TINK.showPopUp = function (options) {
    var deferred = $.Deferred();

    // Setting a promise to be resolve after the pop-up is showed
    options.afterShow = function () {
        deferred.resolve();
    };

    $.fancybox(options);

    return deferred.promise();
};

TINK.closePopUp = function () {
    $.fancybox.close();
};

TINK.openCloseServiceTimeslotModal = function () {
    let $modalWrapper = $('#modal-service-and-timeslot-wrapper, #modal-service-and-timeslot-wrapper .replaceMePlease ');
    $modalWrapper.on('click', function (e) {
        if (e.target == this) {
            $('#modal-service-and-timeslot-trigger').click();
            $modalWrapper.addClass('inactive-timeslot-modal');
        }
    });

    setTimeout(function () {
        $modalWrapper.removeClass('inactive-timeslot-modal');
    }, 300);
};
TINK.inProgress = function ($this) {
    $this.addClass('in-progress relative');
};

TINK.stopProgress = function ($this) {
    $this.removeClass('in-progress relative');
};

TINK.isIE = function () {
    return /MSIE \d|Trident.*rv:/.test(navigator.userAgent);
};

TINK.isIOS = function () {
    return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
};

TINK.matchMediaMobile = function () {
    return window.matchMedia('(max-width: 729px)').matches;
};

TINK.matchMediaMobileTablet = function () {
    return window.matchMedia('(max-width: 1199px)').matches;
};

TINK.matchMediaTabletDesktop = function (verifyMobileHeight) {
    let widthMatch = window.matchMedia('(min-width: 730px)').matches;
    let viewHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    return verifyMobileHeight ? widthMatch && viewHeight > 415 : widthMatch; // to exclude bigger mobile phones in landscape orientation (e.g. Pixel 2XL)
};

TINK.serializeObjectsForAjax = function ($forms) {
    var o = {};
    $forms.each(function () {
        var $form = $(this);
        $.each($form.serializeArray(), function () {
            var prevObject = o;
            var names = this.name.split('.');

            for (var index = 0; index < names.length - 1; index++) {
                if (!prevObject[names[index]]) {
                    prevObject[names[index]] = {};
                }
                prevObject = prevObject[names[index]];
            }

            var lastName = names[names.length - 1];
            if (prevObject[lastName]) {
                if (!prevObject[lastName].push) {
                    prevObject[lastName] = [prevObject[lastName]];
                }
                prevObject[lastName].push(this.value || '');
            } else {
                prevObject[lastName] = this.value || '';
            }
        });
    });
    return o;
};

TINK.removeFromJsonByKeys = function (json, keys, removeEmptyParents) {
    if (!json || !keys) {
        return;
    }

    $.each(keys, function () {
        let prevObject = json;
        let names = this.name.split('.');
        for (let index = 0; index < names.length; index++) {
            if (index === names.length - 1) {
                delete prevObject[names[index]];
                break;
            }
            prevObject = prevObject[names[index]];
            if (typeof prevObject === 'undefined') {
                break;
            }
        }

        // remove empty parents from json now that the children are deleted
        if (removeEmptyParents) {
            prevObject = json;
            for (let index = 0; index < names.length - 1; index++) {
                if ($.isEmptyObject(prevObject[names[index]])) {
                    delete prevObject[names[index]];
                    break;
                } else {
                    prevObject = prevObject[names[index]];
                }
            }
        }
    });
};

TINK.isEqual = function (value, other) {
    return _.isEqual(value, other);
};

TINK.getParamFromUrl = function (param) {
    var results = new RegExp('[\?&]' + param + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    } else {
        return decodeURI(results[1]) || 0;
    }
};

TINK.removeParamFromUrl = function (param, url) {
    var rtn = url.split("?")[0];
    var queryString = url.indexOf("?") !== -1 ? url.split("?")[1] : "";
    if (queryString !== '') {
        var params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            var curParam = params_arr[i].split("=")[0];
            if (curParam === param) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
};

TINK.appendParameterToUrl = function (url, param, value) {
    if (url.indexOf('?') > -1) {
        url += '&';
    } else {
        url += '?';
    }
    url += param + '=' + value;
    return url;
}

TINK.setLocalStorageWithExpiry = function (key, value, expiry) {
    const storageValue = {
        value: value,
        expiry: expiry,
    };
    localStorage.setItem(key, JSON.stringify(storageValue));
}

TINK.getLocalStorageWithExpiry = function (key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}